export enum UrlPrivacyRequestTypes {
  GetAllUrlPrivacyRulesRequest = 'urlprivacy.getall.request',
  GetAllUrlPrivacyRulesSuccess = 'urlprivacy.getall.success',
  GetAllUrlPrivacyRulesFailure = 'urlprivacy.getall.failure',
  DeleteUrlPrivacyRuleRequest = 'urlprivacy.delete.request',
  DeleteUrlPrivacyRuleSuccess = 'urlprivacy.delete.success',
  DeleteUrlPrivacyRuleFailure = 'urlprivacy.delete.failure',
  UpdateUrlPrivacyRuleRequest = 'urlprivacy.update.request',
  UpdateUrlPrivacyRuleSuccess = 'urlprivacy.update.success',
  UpdateUrlPrivacyRuleFailure = 'urlprivacy.update.failure',
}
